<template>

<v-container>

<template>



  <v-data-table
    :headers="headers"
    :items="webinars"
    :items-per-page="100"
    class="elevation-1"
  >
  	
<template v-slot:top>
<v-toolbar flat color="primary">
        <v-toolbar-title><img src="/images/icons/zoom.png" width="32" height="32" /> My Zoom Webinars</v-toolbar-title>
        <v-divider
          class="mx-4"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
    </v-toolbar>
</template>


 <template v-slot:item.actions="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-cloud-download-outline
      </v-icon>
    </template> 	
  </v-data-table>
</template>





  </v-container>
</template>





<!--

//-->


<script>
export default {
  name: 'ShuttleWebinarList',
  data() {
    return {
    	add_dialog:false,
    	drawer:true,
    	itemsPerPage: 12,

    headers: [
          {
            text: 'Title',
            align: 'start',
            sortable: true,
            value: 'topic',
          },
          { text: 'Webinar Date', value: 'start_time' },
          { text: 'Actions', value: 'actions', sortable: false }
        ],	

    webinars: [
        {
            "uuid": "HS9PeLEDSFuiNPkQOG0Ybw==",
            "id": 548253374,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "Webinar: AI in Clinical Practice | January 2020",
            "type": 5,
            "start_time": "2020-01-23T18:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-13T19:58:14Z",
            "join_url": "https://zoom.us/j/548253374"
        },
        {
            "uuid": "xH/ZZxlrS0SjZuPnOXBcOQ==",
            "id": 758226344,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 27 12pm-1pm",
            "type": 5,
            "start_time": "2020-01-27T17:00:00Z",
            "duration": 60,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:13:28Z",
            "join_url": "https://zoom.us/j/758226344"
        },
        {
            "uuid": "EPuEMr18Sia8fNIh3XDJHw==",
            "id": 994602005,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 27 2pm-1pm",
            "type": 5,
            "start_time": "2020-01-27T19:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:14:40Z",
            "join_url": "https://zoom.us/j/994602005"
        },
        {
            "uuid": "ILXvRkzcSCiyVZPq//ARag==",
            "id": 172442929,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 28 12pm-1pm",
            "type": 5,
            "start_time": "2020-01-28T17:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:16:13Z",
            "join_url": "https://zoom.us/j/172442929"
        },
        {
            "uuid": "ctBmDNawQT2AMCgUCZRE5Q==",
            "id": 473657324,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 28 2pm-3pm",
            "type": 5,
            "start_time": "2020-01-28T19:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:18:19Z",
            "join_url": "https://zoom.us/j/473657324"
        },
        {
            "uuid": "cRG5nhYNRjCtD1aqtbaewg==",
            "id": 543644661,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 29 12pm-1pm",
            "type": 5,
            "start_time": "2020-01-29T17:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:18:58Z",
            "join_url": "https://zoom.us/j/543644661"
        },
        {
            "uuid": "6O55zUk9RyK8iUC413ZjSg==",
            "id": 969764417,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 29 2pm-3pm",
            "type": 5,
            "start_time": "2020-01-29T19:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:19:42Z",
            "join_url": "https://zoom.us/j/969764417"
        },
        {
            "uuid": "KTylO5LOTmy+KCMzOnJkTg==",
            "id": 915693103,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 30 12pm-1pm",
            "type": 5,
            "start_time": "2020-01-30T17:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:20:38Z",
            "join_url": "https://zoom.us/j/915693103"
        },
        {
            "uuid": "t8oTLvC4RCeJf/TyPGlVSw==",
            "id": 875960336,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 30 2pm-3pm",
            "type": 5,
            "start_time": "2020-01-30T19:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:21:44Z",
            "join_url": "https://zoom.us/j/875960336"
        },
        {
            "uuid": "IVJaVFAJTf6G74VOppfJxg==",
            "id": 736233281,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 31 12pm-1pm",
            "type": 5,
            "start_time": "2020-01-31T17:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:23:05Z",
            "join_url": "https://zoom.us/j/736233281"
        },
        {
            "uuid": "Xxl8AKjRTlqIJstlI5VkWg==",
            "id": 775141082,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "NIIC-RAD | Jan. 31 2pm-3pm",
            "type": 5,
            "start_time": "2020-01-31T19:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-01-16T16:24:11Z",
            "join_url": "https://zoom.us/j/775141082"
        },
        {
            "uuid": "Yp9tslV+SFKwqmWADUuaLw==",
            "id": 194891964,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "SIIM Sponsor + Advertise Webinar for the Vendor Community",
            "type": 5,
            "start_time": "2020-02-04T19:00:00Z",
            "duration": 30,
            "timezone": "America/New_York",
            "agenda": "SIIM Sponsor + Advertising Partnership Opportunities\n*No CE will be available for this webinar.",
            "created_at": "2020-01-27T22:35:50Z",
            "join_url": "https://zoom.us/j/194891964"
        },
        {
            "uuid": "GPcGzK3pQR+Hl4a3fc/rig==",
            "id": 516867946,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "SIIM Webinar Series | AI Implementation Examples | February 2020",
            "type": 5,
            "start_time": "2020-02-25T18:00:00Z",
            "duration": 60,
            "timezone": "America/New_York",
            "agenda": "Presented by Sana Khalid, MSc; Vidur Mahajan, MBBS, MBA; and Irena Tocino, MD, FACR\n\nModeratored by Teresa Martin-Carreras, MD\n\nIn the past few years, the Radiology and Imaging Informatics community has given a lot of attention to AI, focusing most o",
            "created_at": "2020-01-26T22:58:33Z",
            "join_url": "https://zoom.us/j/516867946"
        },
        {
            "uuid": "qd3P48y9SvOeM2DojHRGag==",
            "id": 394756047,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "HIMSS-SIIM Webinar: Interoperability and Considerations for Standards-Based Exchange of Medical Images | March 2020",
            "type": 5,
            "start_time": "2020-03-23T17:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-03-11T16:40:20Z",
            "join_url": "https://zoom.us/j/394756047"
        },
        {
            "uuid": "qNt168IhT4+QB/7uzBVkJg==",
            "id": 387473646,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "Webinar: AI Infrastructure at an Organization | March 2020",
            "type": 5,
            "start_time": "2020-03-24T17:00:00Z",
            "duration": 60,
            "timezone": "America/New_York",
            "created_at": "2020-03-11T16:21:56Z",
            "join_url": "https://zoom.us/j/387473646"
        },
        {
            "uuid": "XC7bIOD+RnyS3zjOVwO1kQ==",
            "id": 818427420,
            "host_id": "qDSvzVr2QuSUE8JnFusuEg",
            "topic": "Webinar: AI and Workflow Orchestration | April 2020",
            "type": 5,
            "start_time": "2020-04-21T17:00:00Z",
            "duration": 90,
            "timezone": "America/New_York",
            "created_at": "2020-03-11T16:41:06Z",
            "join_url": "https://zoom.us/j/818427420"
        }
    ]

    }
  },

  methods: {
  		playShuttle(id){
  				this.$router.push({path:'/play/' +id});

  		}
    
  },


  mounted() {


    },

}
</script>